module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_0#uecmoQc7wNObFpqUz6HQneA"
    }
  }, [_vm._v("L’histoire de Mobile Mardi Gras et le Carnaval Saisonnier")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01#uUIgYpazpUwmXbh36CVi5t8"
    }
  }, [_vm._v("Chapter 1 – The Crime")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02#uXzifiVUiQ9MnBUBEKh2yTG"
    }
  }, [_vm._v("Chapter 2 – The Victim")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_03#uYnZorHwFbNY3emceXLSifD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 – The Investigation: Finding leads")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_04#uIhdqmribHoRdJ88AyDJml6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 –A New Assignment")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_05#uXKt9rVGEbeUNuOMz6ifTR8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - The Cold Case")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_06#umfS5lIeILmoz6QuTvOEGCH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - The Sting (Getting his DNA)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07#uIRJ8VvCj5OTdkm8NGAiK64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 – The Indictment")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08#uBZD2FfXAJnjBcZHjD8fQQ5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 – The Arrest and Confession")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09#uxoNU7uHtumsXE47pG7bQpG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 – The Search")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10#uqwVY3Ip6j5J9wx277tjCAA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 – The Confession")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11#uagc3QLoEQu5e7qXhLeTRI2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 – The Confession, Day Two")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12#uDs2hGgIeSOVKmsfEDH26pA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 – The Ohio Hearing")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13#uhRPIwQ9UcPYd32VEjmY9f5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 – The Legal Proceedings and Trial")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0